<template>
  <div>
    <el-form label-position="right" ref="form" :model="form.model" :rules="formRules" :validate-on-rule-change="false" label-width="120px">
      <el-row>
        <el-row class="column-name" justify="start">
          <span>基本信息</span>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="内容编号" prop="jpnum">
              <el-input v-model="form.model.jpnum" :disabled="!editable" maxlength="30" placeholder="限30个字符" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="内容名称" prop="description">
              <el-input v-model="form.model.description" :disabled="!editable" maxlength="50" placeholder="限50个字符" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="数据中心" prop="deptid">
              <dictionary-select v-model="form.model.deptid" :disabled="!editable" :factory-name="'department'" :params="{type: 'JOB_PLAN'}" clearable filterable size="small"></dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="类型" prop="type">
              <domain-select v-model="form.model.type" :domainid="'JOBPLANTYPE'" :disabled="!editable" clearable size="small" class="width100"></domain-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="isMeter">
            <el-form-item label="抄表系统类型" prop="mrsType">
              <domain-select v-model="form.model.mrsType" :domainid="'MRSTYPE'" :disabled="!editable" size="small" class="width100"></domain-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="isProblemReform">
            <el-form-item label="整改等级" prop="level">
              <domain-select v-model="form.model.level" :domainid="'WORKORDERLEVEL'" :disabled="!editable" size="small" class="width100"></domain-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="form.model.type === 'LEVEL1' || form.model.type === 'LEVEL2' || form.model.type === 'LEVEL3' ">
            <el-form-item label="MOP" prop="isstandard" >
              <el-radio-group v-model="form.model.isstandard" :disabled="!editable">
                <el-radio label="YES">是</el-radio>
                <el-radio label="NO">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!--<el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="状态" prop="status" v-show="is3P">
              <dictionary-select v-model="form.model.status" :disabled="true" :factory-name="'domain'" :params="'3PSTATUS'" clearable size="small"></dictionary-select>
            </el-form-item>
            <el-form-item label="状态" prop="status" v-show="!is3P">
              <dictionary-select v-model="form.model.status" :disabled="true" :factory-name="'domain'" :params="'JOBPLANSTATUS'" clearable size="small"></dictionary-select>
            </el-form-item>
          </el-col>-->
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="优先级" prop="priority">
              <el-select v-model="form.model.priority" :disabled="!editable" size="small" class="width100">
                <el-option
                        v-for="item in priorityDictionay.items"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="is3P">
            <el-form-item label="发布日期" prop="releasedate">
              <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      v-model="form.model.releasedate"
                      type="date" :disabled="!editable"
                      placeholder="发布日期" size="small">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="is3P">
            <el-form-item label="编制人员" prop="creator">
              <person-select v-model="form.model.creator" @change="form.model.creatorname === $event[1]"
                             :department-id="form.model.deptid" :disabled="!editable"
                             :filterable="true" :clearable="true" size="small"></person-select>
            </el-form-item>
          </el-col>
          <!--<el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="is3P">
            <el-form-item label="编制时间" prop="createdate">
              <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      v-model="form.model.createdate"
                      type="date" :disabled="!editable"
                      placeholder="编制时间" size="small">
              </el-date-picker>
            </el-form-item>
          </el-col>-->
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="录入人员" prop="enterbyname">
              <el-input v-model="form.model.enterbyname" :disabled="true" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="录入时间" prop="enterdate">
              <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="form.model.enterdate" :disabled="true"
                      type="date"
                      placeholder="录入时间" size="small">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" v-if="is3P">
            <el-form-item label="注意事项" prop="notice">
              <el-input v-model="form.model.notice" :disabled="!editable" maxlength="1200" placeholder="限1200个字符" size="small" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>

      <el-row v-if="isSop || isMop">
        <el-row class="column-name" justify="start">
          <span>操作信息</span>
        </el-row>
        <el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item label="资产类型" prop="assettype">
                <dictionary-select v-model="form.model._assettype" :disabled="!editable" :factory-name="'domain'" :params="'ASSETTYPE'" filterable clearable multiple size="small"></dictionary-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item label="设备型号" prop="equipmenttype">
                <el-input v-model="form.model.equipmenttype" :disabled="!editable" maxlength="120" placeholder="限120个字符" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item label="设备厂商" prop="supplier">
                <el-input v-model="form.model.supplier" :disabled="!editable" maxlength="60" placeholder="限60个字符" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item label="标准工时" prop="jpduration">
                <el-input-number v-model="form.model.jpduration" :disabled="!editable" :precision="1" :step="0.1" :min="0.1" size="small" class="width100"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item label="维护人员岗位" prop="post">
                <el-select v-model="form.model._post" :disabled="!editable" multiple clearable size="small" class="width100">
                  <el-option
                          v-for="item in postDictionay.items"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                          >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>
    </el-form>

    <Attachment ownerTable='JOBPLAN'
                docType='JOBPLAN'
                :ownerId='form.model.jobplanid'
                :existed="form.model.jobplanid != null"
                :disabled="!(form.model.jobplanid != null && form.model.status === 'DRAFT')"></Attachment>

    <el-row v-if="is3P && form.model.jobplanid != null">
      <el-row class="column-name" justify="start">
        <span>流转信息</span>
      </el-row>
      <el-row>
        <Workflow ref="workflowHistory" bussiness="3P" :use-new-api="true"
                  :bussinessId="form.model.jobplanid"></Workflow>
      </el-row>
    </el-row>
  </div>
</template>

<script>
  import Emitter from 'element-ui/src/mixins/emitter'
  import DomainSelect from '@/components/domainaln'
  import DeptSelect from '@/components/dept'
  import Attachment from '@/components/attachment'
  import Workflow from '@/components/workflow'
  import {WorkOrderServer} from '@/api'
  import {debounce, merge} from '@/util/common'
  import '@/util/common/date'
  import {AuthInfo} from '@/util/user/authInfo'
  import {Dictionary, dictionaryContainer} from '@/util/common/dictionary'

  import PersonSelect from '@/views/workorder/components/person/person-select'

  import {getJobPlanMixins} from './mixins'
  import DictionarySelect from "../../../components/common/DictionarySelect";

  export default {
    name: "JobplanDetail",
    mixins: [getJobPlanMixins({jobPlanKey: 'form.model'}), Emitter],
    components: {
      DictionarySelect,
      DomainSelect, DeptSelect, Attachment, Workflow, PersonSelect
    },
    props: {
      operation: {
        type: String,
        default: 'detail.show'
      },
      data: {
        type: Object
      }
    },
    data() {
      return {
        op: 'show', // show, add, edit
        priorityDictionay: new Dictionary({
          items: [{
            value: 1,
            text: '1'
          }, {
            value: 2,
            text: '2'
          }, {
            value: 3,
            text: '3'
          }]
        }),
        postDictionay: new Dictionary({
          items: [{
            value: 'G1',
            text: 'G1'
          }, {
            value: 'G2',
            text: 'G2'
          }, {
            value: 'G3',
            text: 'G3'
          }, {
            value: 'G4',
            text: 'G4'
          }, {
            value: 'G5',
            text: 'G5'
          }, {
            value: 'G6',
            text: 'G6'
          }, {
            value: 'G7',
            text: 'G7'
          }]
        }),
        statusOptions: [{
          value: '0',
          text: '草稿'
        }, {
          value: '1',
          text: '活动'
        }, {
          value: '2',
          text: '不活动'
        }, {
          value: '3',
          text: '不活动'
        }],
        form: {
          model: {
            jobplanid: null,
            jpnum: '',
            description: '',
            deptid: '',
            type: '',
            mrsType: '',
            level: '',
            priority: '',
            status: '',
            isstandard: '',
            releasedate: '',
            creator: '',
            creatorname: '',
            createdate: null,
            reviser: '',
            revisername: '',
            revisedate: '',
            enterby: '',
            enterbyname: '',
            enterdate: '',
            notice: '',

            assettype: null,
            _assettype: [],
            equipmenttype: '',
            supplier: '',
            jpduration: '',
            post: null,
            _post: [],
          },
        }
      }
    },
    computed: {
      formRules() {
        let jpnum = [
          { type: 'string', required: true, message: '请输入内容编号', trigger: 'blur' },
          { max: 30, message: '限30个字符', trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (value == null || value === '' || value.trim() === '') {
                callback('请输入内容编号');
              } else {
                WorkOrderServer.jobPlan.count({
                  ne_jobplanid: this.form.model['jobplanid'],
                  eq_jpnum: value
                }).then((res) => {
                  if (res.data.code === 200) {
                    if (res.data.result > 0) {
                      callback(new Error('内容编号已存在，请重新输入'));
                    } else {
                      callback();
                    }
                  } else {
                    callback();
                  }
                }, (error) => {
                  callback(error);
                })
              }
            }
          }
        ];
        let description = [
          { type: 'string', required: true, message: '请输入内容名称', trigger: 'blur' },
          { max: 50, message: '限50个字符', trigger: 'blur' },
        ];
        let deptid = [
          { required: true, message: '请选择数据中心', trigger: 'change' }
        ];
        let releasedate = [
          { required: true, message: '请选择发布日期', trigger: 'change' }
        ];
        let creator = [
          { required: true, message: '请选择编制人员', trigger: 'change' }
        ];
        let rules = {
          jpnum: jpnum,
          description: description,
          type: [
            { required: true, message: '请选择类型', trigger: 'change' }
          ],
          notice: [
            { max: 1200, message: '限1200个字符', trigger: 'blur' },
          ],
          equipmenttype: [
            { max: 120, message: '限120个字符', trigger: 'blur' },
          ],
          supplier: [
            { max: 60, message: '限60个字符', trigger: 'blur' },
          ],
        };
        if (this.is3P) {
          rules.deptid = deptid;
          rules.releasedate = releasedate;
          rules.creator = creator;
        }
        if (this.isMeter) {
          rules.mrsType = [
            { required: true, message: '请选择抄表系统类型', trigger: 'change' }
          ];
        }
        if (this.isProblemReform) {
          rules.level = [
            { required: true, message: '请选择整改等级', trigger: 'change' }
          ];
        }
        return rules;
      },
      defaultStatus() {
        let status = null;
        if (this.op === 'detail.add') {
          status = 'DRAFT';
        }
        return status;
      },
      editable() {
        return (this.op === 'detail.add' || this.op === 'detail.edit' && this.form.model.jobplanid != null && this.form.model.status === 'DRAFT');
      },
    },
    watch: {
      operation: {
        handler(value) {
          this.op = value;
        }
      },
      op: {
        handler(value) {
          this.$emit('switch-operation', value);
        }
      },
      data: {
        deep: true,
        handler(value, old) {
          if (value['jobplanid'] == null) {
            this.form.model = {
              priority: '3',
              status: 'DRAFT',
              isstandard: 'NO',
              enterby: AuthInfo.userName,
              enterbyname: AuthInfo.userRealName,
              enterdate: new Date().Format('yyyy-MM-dd hh:mm:ss'),
              changeby: AuthInfo.userName,
              changebyname: AuthInfo.userRealName,
              changedate: new Date().Format('yyyy-MM-dd hh:mm:ss'),
            };
            this.$nextTick(() => {
              this.$refs.form.clearValidate();
            });
          } else {
            WorkOrderServer.jobPlan.get(value['jobplanid']).then((res) => {
              if (res.data.code === 200) {
                this.form.model = this._toModel(res.data.result);
              }
            })
          }

          if (value['status'] !== old['status']) {
            if (this.$refs.workflowHistory != null) {
              this.$refs.workflowHistory.getHistoryList();
            }
          }
        }
      },
      defaultStatus: {
        immediate: true,
        handler() {
          if (this.defaultStatus != null) {
            this.form.model.status = this.defaultStatus;
          }
        }
      }
    },
    methods: {
      loadFormModel(id) {
        WorkOrderServer.jobPlan.get(id).then((res) => {
          if (res.data.code === 200) {
            this.form.model = this._toModel(res.data.result);
          }
        })
      },
      saveAdd() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let data = this._toData(this.form.model);
            WorkOrderServer.jobPlan.add(
                data, {loading: true}
            ).then((res) => {
              if (res.data.code === 200) {
                this.op = 'detail.show';
                this.$message.success('保存成功');

                let model = this._toModel(res.data.result);
                this.form.model = model;
                this.$emit('current-change', model);
              }
            });
          } else {
            return false;
          }
        });
      },
      saveEdit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let data = this._toData(this.form.model);
            WorkOrderServer.jobPlan.update(
                data['jobplanid'], data, {loading: true}
            ).then((res) => {
              if (res.data.code === 200) {
                this.op = 'detail.show';
                this.$message.success('保存成功');

                let model = this._toModel(res.data.result);
                this.form.model = model;
                this.$emit('current-change', model);
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            return false;
          }
        });
      },
      cancelEdit() {
        this.op = 'detail.show';
        this.$refs['form'].resetFields();
        this.loadFormModel(this.data['jobplanid']);
      },
      remove() {
        this.$confirm('确定删除吗？', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          WorkOrderServer.jobPlan.delete(this.form.model['jobplanid'], {loading: true}).then((res) => {
            if (res.data.code === 200) {
              this.dispatch('JobplanIndex', 'switch-operation', 'list.query');
              this.dispatch('JobplanIndex', 'switch-tab', 'list');
              this.$message.success('删除成功！');
            } else {
              this.$message.error(`删除失败：${res.data.message}`);
            }
          });
        }, () => {})
      },

      _toModel(data) {
        data._assettype = data.assettype == null ? [] : JSON.parse(data.assettype);
        data._post = data.post == null ? [] : JSON.parse(data.post);
        return data;
      },

      _toData(model) {
        model.assettype = model._assettype == null ? null : JSON.stringify(model._assettype);
        model.post = model._post == null ? null : JSON.stringify(model._post);
        return model;
      }
    }
  }
</script>

<style scoped>

</style>
